import React from 'react';
import './Cart.scss';
import { imagePlaceHolder, handIcon, arrowCircleIcon } from '../../utils/images'; // Make sure the path to images is correct
import { useSystemLogs } from '../../hook/useSystemLogs';
import { useCaptureData } from '../../hook/useCaptureData';

export const Cart = () => {
  // Use our adaptive polling hooks
  const { 
    data: systemLogs, 
    isLoading: systemLogsLoading, 
    error: systemLogsError,
    activityLevel: systemActivityLevel,
    isPageVisible: systemPageVisible,
    pollingInterval: systemPollingInterval,
    forceRefresh: forceRefreshSystemLogs 
  } = useSystemLogs();

  const {
    // captureData,
    captureLoading,
    captureError,
    latestCapture,
    authenticatedImageUrl,
    activityLevel: captureActivityLevel,
    isPageVisible: capturePageVisible,
    pollingInterval: capturePollingInterval,
    forceRefreshCaptures: forceRefreshCaptureData
  } = useCaptureData();

  // All data fetching is now handled by the custom hooks above
  return (
    <div className="cart">
      <div className="cart__profile">
        {captureLoading ? (
          <div className="cart__image-loading" >
            Loading image...
          </div>
        ) : (
          <img 
            src={authenticatedImageUrl || imagePlaceHolder} 
            alt={latestCapture ? "Captured customer" : "Place holder"} 
            className="cart__image" 
          />
        )}
      </div>

      <div className="cart__tags">
        {captureLoading ? (
          <span className="cart__tag cart__tag--loading">Loading AI tags...</span>
        ) : latestCapture && latestCapture.ai_tags.length > 0 ? (
          latestCapture.ai_tags.map((tag, index) => (
            <span key={index} className="cart__tag cart__tag--ai">
              {tag}
            </span>
          ))
        ) : (
          <span className="cart__tag cart__tag--gender">No AI tags available</span>
        )}
      </div>

      <div className="cart__devider"></div>

      <div className="cart__log">
        <h3 className="cart__log-title">System Log</h3>
        
        {/* Debug info - remove this in production */}
          {/* <div><strong>Capture Data:</strong> {capturePageVisible ? 'Active' : 'Paused'} | 
          <strong> Activity:</strong> {captureActivityLevel} | 
          <strong> Interval:</strong> {capturePollingInterval === 0 ? 'Stopped' : `${capturePollingInterval/1000}s`}</div>
          <br />
          <div><strong>System Logs:</strong> {systemPageVisible ? 'Active' : 'Paused'} | 
          <strong> Activity:</strong> {systemActivityLevel} | 
          <strong> Interval:</strong> {systemPollingInterval === 0 ? 'Stopped' : `${systemPollingInterval/1000}s`}</div> */}
  
          {systemLogsError && <div style={{color: 'red'}}>System Logs Error: {systemLogsError.message}</div>}
          {captureError && <div style={{color: 'red'}}>Capture Error: {captureError.message}</div>}

        <div className="cart__log-container">
          {systemLogsLoading ? (
            <div className="cart__log-loading">Loading system logs...</div>
          ) : systemLogs && systemLogs.length > 0 ? (
            systemLogs.map((log) => (
              <div key={log.id} className="cart__log-entry">
                <div className="cart__log-action">
                  <img src={handIcon} alt="Log Icon" className="cart__log-icon" />
                  <span className="cart__log-text">{log.action}</span>
                  <span className="cart__log-time">
                    {new Date(log.timestamp).toLocaleTimeString()}
                  </span>
                </div>

                <div className="cart__log-device">
                  <img src={arrowCircleIcon} alt="Arrow Icon" className="cart__log-icon" />
                  <p className="cart__log-device-details">{log.response}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="cart__log-empty">No logs available</div>
          )}
        </div>
      </div>
    </div>
  );
};